// Vendor modules
import "@uirouter/angularjs";
import 'angular-ui-bootstrap';

import QBLoginComponent from './qb-login/qb-login.component';
import QBSuppliedConnection from './supplied-connection/supplied-connection.component';


const DEPENDENCIES = [
  'ui.router',
  'record-utilities',
  'ui.bootstrap'
];

angular
  .module('ais.qb-auth', DEPENDENCIES)
  .component('qbLogin', QBLoginComponent)
  .component('qbSuppliedConnection', QBSuppliedConnection);
